import { FamiliaZipLinks, ZipLink } from "../types";

// Agrupamento automático por prefixo: ops adjacentes na ordem alfabética que
// compartilham prefixo de pelo menos MIN_PREFIX letras formam uma família
// (rayo + rayogyn + rayosp → "rayo"; lionsbsb + lionssp → "lions"). Sem lista
// hardcoded — franquia nova cai sozinha no grupo certo.
const MIN_PREFIX = 3;

const prefixoComum = (a: string, b: string): string => {
  let i = 0;
  while (i < a.length && i < b.length && a[i] === b[i]) i++;
  return a.slice(0, i);
};

export const agruparPorFamilia = (links: ZipLink[]): FamiliaZipLinks[] => {
  const ordenados = [...links].sort((a, b) => a.ops.localeCompare(b.ops));
  const familias: FamiliaZipLinks[] = [];

  for (const link of ordenados) {
    const atual = familias[familias.length - 1];
    const prefixo = atual ? prefixoComum(atual.nome, link.ops.toLowerCase()) : "";
    if (atual && prefixo.length >= MIN_PREFIX) {
      // O nome da família encolhe para o prefixo comum a todos os membros
      atual.nome = prefixo;
      atual.links.push(link);
    } else {
      familias.push({ nome: link.ops.toLowerCase(), links: [link] });
    }
  }

  return familias;
};

export const familiaTemLinkPronto = (familia: FamiliaZipLinks): boolean =>
  familia.links.some((l) => (l.ready && l.url) || l.csvUrl);

/**
 * Texto padrão da família — template aprovado pelo usuário. Ops sem nenhum
 * arquivo pronto são omitidas.
 */
export const textoDaFamilia = (
  familia: FamiliaZipLinks,
  periodo: { segunda: string; domingo: string },
  validade: string,
  formatData: (d: string) => string
): string => {
  const blocos = familia.links
    .filter((l) => (l.ready && l.url) || l.csvUrl)
    .map((l) => {
      const linhas = [l.ops.toUpperCase()];
      if (l.ready && l.url) linhas.push(`• NFS da semana (ZIP): ${l.url}`);
      if (l.csvUrl) linhas.push(`• Saldo Remanescente (CSV): ${l.csvUrl}`);
      return linhas.join("\n");
    });

  return [
    `NFS Entrego — família ${familia.nome.toUpperCase()}`,
    `Semana ${formatData(periodo.segunda)} a ${formatData(periodo.domingo)}`,
    "",
    blocos.join("\n\n"),
    "",
    `⚠️ Links válidos até ${validade} (7 dias após a geração). Depois disso é preciso gerar novos links.`,
    "",
    "O ZIP contém os PDFs das notas fiscais emitidas pelos prestadores da operação na semana. O CSV traz o detalhamento do Saldo Remanescente apto a emissão de NFS.",
  ].join("\n");
};
